import { merge } from 'lodash'
import isFunction from 'lodash/isFunction'
import { limitInteger18, validateNumber } from '@/utils/validate'

import { getSalesLeadCityList, getSalesLeadStoreList } from '@/api/domain/orders'
import { getEnum } from '@/api/global'
import { FORM_ITEM_ARR, COLUMN_FIELD, FIELD_TEXT_MAP } from '../constant'
import { getAllEmployeeList } from '@/api/carManage/index.js'

export const getTableColumnsConfig = (self) => {
  return COLUMN_FIELD.map((field) => {
    const label = FIELD_TEXT_MAP.get(field)
    const commonProps = {
      name: field,
      columnProps: {
        label,
        prop: field,
      },
    }
    let otherProps = {}
    switch (field) {
      case 'id':
        commonProps.columnProps.width = 80
        commonProps.render = ({ row }) => {
          if (!self.judgePermission('rent_car_clue_sales_detail') && !self.judgePermission('rent_car_clue_detail')) return row.id
          return <span class="a-hover-link" onClick={() => self.handleDetailBtnClick(row)}>{row.id}</span>
        }
        break
      case 'gmtCreate':
        commonProps.columnProps.width = 180
        break
      case 'label':
        otherProps = {
          type: 'manual',
        }
        commonProps.columnProps.width = 200
        delete commonProps.columnProps.prop
        break
      case 'followTime':
        commonProps.columnProps.label = '最近跟进时间'
        commonProps.columnProps.width = 180
        break
      case 'nextFollowTime':
        commonProps.columnProps.width = 180
        break
      case 'followUser':
        commonProps.columnProps.label = '当前跟进人'
        commonProps.columnProps.width = 120
        break
      case 'followRemarks':
        commonProps.columnProps.label = '最近一次跟进描述'
        commonProps.columnProps.width = 300
        commonProps.showEllipsisTooltip = true
        commonProps.limitEllipsisLine = 1
        break
      default:
        break
    }
    return Object.assign(commonProps, otherProps)
  })
}

// 通过接口获取 select 数据
const getSelectListOptions = async ({ fetchData, callback }) => {
  let list = []
  try {
    const { data, code } = await fetchData()
    if (code === 1) {
      list = data
    } else {
      throw new Error(`接口code${code}`)
    }
  } catch (error) {
    list = []
  }
  return isFunction(callback) ? callback(list) : list
}

export const getFormItemListConfig = ($vueVm) => {
  return FORM_ITEM_ARR.filter((item) => !item.hidden).map((item) => {
    const { componentsType, label, field, elConfig, itemConfig } = item
    const commonFormItemProps = {
      el: componentsType || 'input',
      itemConfig: {
        label,
        prop: field,
        ...itemConfig,
      },
      elConfig,
    }
    // city name 配置远程搜索
    const otherFormItemProps = {}
    switch (field) {
      case 'channelType':
        getEnum({
          type: 'clueChannelTypeEnum',
        }).then(({ data }) => {
          commonFormItemProps.elConfig.options.list = data || []
        })
        break
      case 'channel':
        getEnum({
          type: 'clueChannelNameEnum',
        }).then(({ data }) => {
          commonFormItemProps.elConfig.options.list = data || []
        })
        break
      case 'city':
        getSelectListOptions({ fetchData: getSalesLeadCityList }).then((list) => {
          commonFormItemProps.elConfig.options.list = list
        })
        break
      case 'storeName':
        getSelectListOptions({ fetchData: getSalesLeadStoreList }).then((list) => {
          commonFormItemProps.elConfig.options.list = list
        })
        break
      case 'id':
        otherFormItemProps.elConfig = {
          ...commonFormItemProps.elConfig,
          events: {
            input: (e) => {
              limitInteger18(e, (val) => {
                if ($vueVm && $vueVm.handleLeadIdInputEvent && typeof $vueVm.handleLeadIdInputEvent === 'function') {
                  $vueVm.handleLeadIdInputEvent(val)
                }
              })
            },
          },
        }
        break
      case 'phone':
        otherFormItemProps.elConfig = {
          ...commonFormItemProps.elConfig,
          events: {
            input: (e) => {
              validateNumber(e, (val) => {
                if ($vueVm && $vueVm.handlePhoneInputEvent && typeof $vueVm.handlePhoneInputEvent === 'function') {
                  $vueVm.handlePhoneInputEvent(val)
                }
              })
            },
          },
        }
        break
      case 'followUser':
        getAllEmployeeList().then(({ data }) => {
          commonFormItemProps.elConfig.options.list = data || []
        })
        break
      default:
        break
    }
    return merge(commonFormItemProps, otherFormItemProps)
  })
}

